import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex lg:flex-wrap lg:flex-row flex-col lg:items-center min-h-screen lg:justify-between" }
const _hoisted_2 = { class: "w-full px-4 lg:w-1/2 sm:px-20 lg:py-0 py-6" }
const _hoisted_3 = { class: "sm:max-w-[360px] mx-auto" }
const _hoisted_4 = { class: "" }
const _hoisted_5 = { class: "mb-6" }
const _hoisted_6 = { class: "mb-6" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "mt-6 text-center" }, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "/login",
    class: "text-sm m-0 text-primary-600 hover:text-primary-800 transition"
  }, "Return to Login")
], -1)

import { ref } from 'vue';
import { numberonly } from "@/components/composables/useNumberOnly";
import {
    IonPage,
    IonContent 
} from '@ionic/vue';
import ButtonComponent from '@/components/buttons/ButtonComponent.vue';
import PasswordInput from '@/components/inputs/PasswordInput.vue';
import ConfirmationModal from '@/components/modals/ConfirmationModal.vue';
import SuccessModal from '@/components/modals/SuccessModal.vue';

import AuthLogo from "../Components/AuthLogo.vue";
import AuthTitle from "../Components/AuthTitle.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ResetPin',
  setup(__props) {

const showConfirmation = ref<boolean>(false);
const showSuccess = ref<boolean>(false);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonPage), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonContent), { fullscreen: true }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(AuthLogo),
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createVNode(AuthTitle, {
                  title: "New PIN",
                  description: "Kindly provide your new PIN"
                }),
                _createElementVNode("form", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    _createVNode(PasswordInput, {
                      label: "New PIN",
                      placeholder: "New PIN",
                      name: "new-pin",
                      id: "new-pin",
                      maxlength: 6,
                      onKeypress: _unref(numberonly)
                    }, null, 8, ["onKeypress"])
                  ]),
                  _createElementVNode("div", _hoisted_6, [
                    _createVNode(PasswordInput, {
                      label: "Confirm PIN",
                      placeholder: "Confirm PIN",
                      name: "confirm-pin",
                      id: "confirm-pin",
                      maxlength: 6,
                      onKeypress: _unref(numberonly)
                    }, null, 8, ["onKeypress"])
                  ]),
                  _createVNode(ButtonComponent, {
                    type: "button",
                    size: "large",
                    btnWidth: "w-full rounded-lg",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (showConfirmation.value = true))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Reset PIN ")
                    ]),
                    _: 1
                  }),
                  _hoisted_7
                ])
              ])
            ])
          ]),
          _createVNode(ConfirmationModal, {
            show: showConfirmation.value,
            onCancel: _cache[1] || (_cache[1] = ($event: any) => (showConfirmation.value = false)),
            onConfirm: _cache[2] || (_cache[2] = ($event: any) => {showSuccess.value = true; showConfirmation.value = false}),
            "cancel-text": "Cancel",
            "action-text": "Reset",
            title: "Reset PIN",
            content: "Are you sure you wish to reset your PIN?"
          }, null, 8, ["show"]),
          _createVNode(SuccessModal, {
            show: showSuccess.value,
            onConfirm: _cache[3] || (_cache[3] = ($event: any) => (showSuccess.value = false)),
            "action-text": "Confirm",
            title: "PIN Updated!",
            content: "Your PIN has been successfully updated"
          }, null, 8, ["show"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})